'use client'

import { Image } from '@vinted/web-ui'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { NewAgainForNoweverlSectionModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = {
  data: NewAgainForNoweverlSectionModel
}

export const NewAgainForNoweverSection = ({
  data: { title, description, image, imageMobile },
}: Props) => {
  const renderImage = (imgSrc?: string) => {
    if (!imgSrc) return null

    return (
      <div className="new-again__for-nowever-image">
        <Image src={imgSrc} testId="new-again_for-nowever-image" scaling="cover" />
      </div>
    )
  }

  return (
    <section className="new-again_for-nowever-section" data-testid="for-nowever-section">
      <h3 className="new-again__for-nowever-title">{title}</h3>
      <p className="new-again__for-nowever-description">{description}</p>
      <ShowAtBreakpoint breakpoint="portables">{renderImage(imageMobile)}</ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="desktops">{renderImage(image)}</ShowAtBreakpoint>
    </section>
  )
}
